<svg
	class={$$props.class || ''}
	xmlns="http://www.w3.org/2000/svg"
	x="0px"
	y="0px"
	viewBox="0 0 64 64"
	enable-background="new 0 0 64 64"
	xml:space="preserve"
>
	<circle fill="#FFC400" cx="32" cy="32" r="32" />
	<circle fill="#FC594F" cx="54" cy="54" r="5" />
	<path
		fill="#FFFFFF"
		d="M22.8,25.61h5.184h5.184c0,0,0.048,0.458,0.097,1.412H46.08c-2.05-5.799-7.579-9.956-14.08-9.956 c-6.501,0-12.03,4.156-14.08,9.956h4.784C22.752,26.069,22.8,25.61,22.8,25.61z"
	/>
	<path
		fill="#EE1C25"
		d="M31.107,36.978c-0.992,0.961-2.149,1.634-3.123,2.102c-0.973-0.469-2.131-1.141-3.123-2.102H17.92 c2.05,5.799,7.579,9.956,14.08,9.956c6.502,0,12.03-4.156,14.08-9.956H31.107z"
	/>
	<path
		fill="#0B4EA2"
		d="M46.08,27.022H33.265c0.051,0.998,0.104,2.54,0.104,4.683c0,2.349-0.996,4.046-2.262,5.272H46.08 c0.551-1.557,0.853-3.232,0.853-4.978S46.631,28.58,46.08,27.022z"
	/>
	<path
		fill="#0B4EA2"
		d="M24.862,36.978c-1.265-1.226-2.262-2.924-2.262-5.272c0-2.143,0.053-3.685,0.104-4.683H17.92 c-0.551,1.557-0.853,3.232-0.853,4.978s0.303,3.42,0.853,4.978H24.862z"
	/>
	<path
		fill="#FFFFFF"
		d="M27.984,25.61H22.8c0,0-0.048,0.458-0.097,1.412c-0.051,0.998-0.104,2.54-0.104,4.683 c0,2.349,0.996,4.046,2.262,5.272c0.992,0.961,2.149,1.634,3.123,2.102c0.973-0.469,2.131-1.141,3.123-2.102 c1.266-1.226,2.262-2.924,2.262-5.272c0-2.143-0.052-3.685-0.104-4.683c-0.049-0.954-0.097-1.412-0.097-1.412H27.984z M32.924,31.758c0,1.407-0.392,2.557-0.986,3.501c-1.028,1.634-2.666,2.644-3.954,3.265c-1.288-0.621-2.926-1.631-3.954-3.265 c-0.594-0.944-0.985-2.094-0.985-3.501c0-3.844,0.184-5.592,0.184-5.592h4.756h4.756C32.74,26.166,32.924,27.914,32.924,31.758z"
	/>
	<path
		fill="#EE1C25"
		d="M27.984,26.166h-4.756c0,0-0.184,1.748-0.184,5.592c0,1.407,0.392,2.557,0.985,3.501 c0.265-0.466,0.677-0.969,1.243-0.969c0.835,0,1.14,0.673,1.14,0.673s0.397-1.008,1.137-1.321v-1.992 c-0.62-0.008-1.703-0.002-2.58,0.292c0,0,0.025-0.342,0.025-0.741c0-0.399-0.025-0.741-0.025-0.741 c0.956,0.32,2.03,0.298,2.58,0.289v-1.333c-0.501-0.004-1.224,0.02-2.042,0.293c0,0,0.025-0.342,0.025-0.741 c0-0.399-0.025-0.741-0.025-0.741c0.816,0.273,1.538,0.297,2.039,0.293c-0.026-0.844-0.272-1.908-0.272-1.908 s0.506,0.04,0.709,0.04s0.709-0.04,0.709-0.04s-0.246,1.064-0.272,1.908c0.501,0.004,1.223-0.02,2.039-0.293 c0,0-0.025,0.342-0.025,0.741c0,0.399,0.025,0.741,0.025,0.741c-0.817-0.273-1.54-0.297-2.042-0.293v1.333 c0.55,0.009,1.624,0.03,2.58-0.289c0,0-0.025,0.342-0.025,0.741c0,0.399,0.025,0.741,0.025,0.741c-0.877-0.293-1.96-0.3-2.58-0.292 v1.992c0.741,0.313,1.137,1.321,1.137,1.321s0.305-0.673,1.14-0.673c0.566,0,0.978,0.503,1.243,0.969 c0.594-0.944,0.986-2.094,0.986-3.501c0-3.844-0.184-5.592-0.184-5.592H27.984z"
	/>
	<path
		fill="#FFFFFF"
		d="M28.419,33.642v-1.992c0.62-0.008,1.703-0.002,2.58,0.292c0,0-0.025-0.342-0.025-0.741 c0-0.399,0.025-0.741,0.025-0.741c-0.956,0.32-2.03,0.298-2.58,0.289v-1.333c0.502-0.004,1.224,0.02,2.042,0.293 c0,0-0.025-0.342-0.025-0.741c0-0.399,0.025-0.741,0.025-0.741c-0.816,0.273-1.538,0.297-2.039,0.293 c0.026-0.844,0.272-1.908,0.272-1.908s-0.506,0.04-0.709,0.04s-0.709-0.04-0.709-0.04s0.246,1.064,0.272,1.908 c-0.501,0.004-1.223-0.02-2.039-0.293c0,0,0.025,0.342,0.025,0.741c0,0.399-0.025,0.741-0.025,0.741 c0.817-0.273,1.54-0.297,2.042-0.293v1.333c-0.55,0.009-1.624,0.03-2.58-0.289c0,0,0.025,0.342,0.025,0.741 c0,0.399-0.025,0.741-0.025,0.741c0.877-0.293,1.96-0.3,2.58-0.292v1.992c0.135-0.057,0.277-0.098,0.435-0.098 C28.142,33.544,28.284,33.585,28.419,33.642z"
	/>
	<path
		fill="#0B4EA2"
		d="M30.696,34.29c-0.835,0-1.14,0.673-1.14,0.673s-0.397-1.008-1.137-1.321 c-0.135-0.057-0.277-0.098-0.435-0.098c-0.158,0-0.3,0.041-0.435,0.098c-0.74,0.313-1.137,1.321-1.137,1.321 s-0.305-0.673-1.14-0.673c-0.566,0-0.978,0.503-1.243,0.969c1.028,1.634,2.666,2.644,3.954,3.265 c1.288-0.621,2.926-1.631,3.954-3.265C31.674,34.793,31.262,34.29,30.696,34.29z"
	/>
	<circle
		fill="none"
		stroke="#282E35"
		stroke-width="1.4"
		stroke-miterlimit="10"
		cx="32"
		cy="32"
		r="14.933"
	/>
</svg>
